var _ellipse, _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6423473E45A6D53A4205D7A0StationaryDesignIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.1842,
    cy: 13.6429,
    rx: 13.447,
    ry: 13.6429,
    fill: "#FF7020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9629 11.2505H49.9169L56.9936 18.8429L63.9762 26.0357V65.776H22.9629V11.2505Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6292 11.2188V26.2432H64.2964",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.26166,
    y: 49.0156,
    width: 39.8404,
    height: 26.1052,
    fill: "#060606",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 49.5659L20.9743 63.9206L40.9487 49.5659",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6423473E45A6D53A4205D7A0StationaryDesignIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6423473e45a6d53a4205d7a0_stationary-design-icon-darkstudio-x-webflow-template.d2e256ed0ed650d8818e69451c413fb9.svg";
export { ForwardRef as ReactComponent };